import { render, staticRenderFns } from "./BlockParallax.vue?vue&type=template&id=6bb51d0c&scoped=true&"
import script from "./BlockParallax.vue?vue&type=script&lang=js&"
export * from "./BlockParallax.vue?vue&type=script&lang=js&"
import style0 from "./BlockParallax.vue?vue&type=style&index=0&id=6bb51d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb51d0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VParallax})
